module.exports = __webpack_public_path__ + "img/street-lamps-bw.74e6ab11.jpg";